import React from "react";
import Svg, {
  Path,
  Defs,
  LinearGradient,
  Stop,
  Rect,
  G,
  ClipPath,
} from "react-native-svg";
import { uniqueId } from "lodash";

export default function OperationIcon(props) {
  const filterId = "clip0_operation" + uniqueId();
  const gradientId = "paint0_linear_operation" + uniqueId();
  const filterUrl = "url(#" + filterId + ")";
  const gradientUrl = "url(#" + gradientId + ")";

  const width = props.width || 24;
  const height = props.height || 24;

  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <G clipPath={filterUrl}>
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.5266 3.39077C15.0212 3.39077 15.4222 2.9898 15.4222 2.49519C15.4222 2.00057 15.0212 1.59961 14.5266 1.59961C14.032 1.59961 13.6311 2.00057 13.6311 2.49519C13.6311 2.9898 14.032 3.39077 14.5266 3.39077ZM19.855 7.31961C20.377 7.31961 20.8001 6.88843 20.8001 6.35653C20.8001 5.82463 20.377 5.39344 19.855 5.39344C19.3331 5.39344 18.91 5.82463 18.91 6.35653C18.91 6.88843 19.3331 7.31961 19.855 7.31961ZM11.5699 7.79667C11.5699 8.29129 11.1689 8.69225 10.6743 8.69225C10.1797 8.69225 9.77871 8.29129 9.77871 7.79667C9.77871 7.30206 10.1797 6.90109 10.6743 6.90109C11.1689 6.90109 11.5699 7.30206 11.5699 7.79667ZM16.1018 12.6706C16.5964 12.6706 16.9974 12.2696 16.9974 11.775C16.9974 11.2804 16.5964 10.8794 16.1018 10.8794C15.6072 10.8794 15.2063 11.2804 15.2063 11.775C15.2063 12.2696 15.6072 12.6706 16.1018 12.6706ZM18.973 3.42677C18.973 3.92138 18.572 4.32235 18.0774 4.32235C17.5828 4.32235 17.1818 3.92138 17.1818 3.42677C17.1818 2.93215 17.5828 2.53119 18.0774 2.53119C18.572 2.53119 18.973 2.93215 18.973 3.42677ZM11.4889 5.20443C11.9836 5.20443 12.3845 4.80346 12.3845 4.30885C12.3845 3.81423 11.9836 3.41327 11.4889 3.41327C10.9943 3.41327 10.5934 3.81423 10.5934 4.30885C10.5934 4.80346 10.9943 5.20443 11.4889 5.20443ZM20.089 9.79486C20.089 10.2895 19.688 10.6904 19.1934 10.6904C18.6988 10.6904 18.2979 10.2895 18.2979 9.79486C18.2979 9.30025 18.6988 8.89928 19.1934 8.89928C19.688 8.89928 20.089 9.30025 20.089 9.79486ZM15.1342 8.84975H15.3142C15.7241 8.8409 16.1155 8.67741 16.4098 8.39207C16.7042 8.10673 16.8799 7.72064 16.9015 7.31123C16.9231 6.90182 16.7892 6.49936 16.5265 6.18458C16.2638 5.8698 15.8919 5.66596 15.4852 5.61396C15.4268 5.60948 15.3681 5.60948 15.3097 5.61396C14.8995 5.62183 14.5075 5.7846 14.2123 6.06958C13.9172 6.35456 13.7408 6.74065 13.7186 7.15031C13.6964 7.55997 13.83 7.96287 14.0925 8.2781C14.3551 8.59333 14.7272 8.79755 15.1342 8.84975ZM13.8079 9.08011C14.1625 9.37001 14.5935 9.55103 15.0487 9.60132L15.1882 9.61032L6.36742 21.6354C6.28949 21.7419 6.19133 21.832 6.07855 21.9005C5.96576 21.969 5.84058 22.0145 5.71016 22.0346C5.57974 22.0547 5.44664 22.0488 5.31849 22.0174C5.19033 21.986 5.06963 21.9296 4.9633 21.8514L4.40975 21.4464C4.19825 21.2884 4.05715 21.0538 4.01676 20.7929C3.97637 20.5321 4.03991 20.2658 4.19373 20.0513L13.0505 7.96768C13.1903 8.40384 13.4533 8.79021 13.8079 9.08011Z"
          fill={gradientUrl}
        />
      </G>
      <Defs>
        <LinearGradient
          id={gradientId}
          x1="4.00488"
          y1="6.03383"
          x2="14.9661"
          y2="24.4313"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#05858A" />
          <Stop offset="1" stopColor="#2AE8CB" />
        </LinearGradient>
        <ClipPath id={filterId}>
          <Rect
            width="16.8"
            height="20.4453"
            fill="white"
            transform="translate(4 1.59961)"
          />
        </ClipPath>
      </Defs>
    </Svg>
  );
}
